export default "__VITE_ASSET__31e2cfc4__"